import { render } from "./PublishIconNew.vue?vue&type=template&id=b768c372"
import script from "./PublishIconNew.vue?vue&type=script&lang=js"
export * from "./PublishIconNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__